import React, { useState, useLayoutEffect } from "react";

export const useResumePreviewSize = () => {
    const [resumePreviewSize, setResumePreviewSize] = useState([0, 0, ''])
    const updateResumeSize = () => {
        const resumeDiv = document.getElementById('preview-resume');
        if (resumeDiv != null) {
            const scale = getScale(resumeDiv.clientWidth, resumeDiv.clientHeight);
            setResumePreviewSize([resumeDiv.clientWidth, resumeDiv.clientHeight, scale])
        }
    }

    const getScale = (w, h) => {
        return w / 640;
    }

    useLayoutEffect(() => {
        window.addEventListener('resize', updateResumeSize);
        updateResumeSize();
        return () => window.removeEventListener('resize', updateResumeSize);
    }, [])
    return [resumePreviewSize[0], resumePreviewSize[1], resumePreviewSize[2]]
}